import { PostProperties } from "../types";
import image from "../img/lostGemGemini.jpg";

const post: PostProperties = {
  id: 35,
  title: "Spencer Kincy aka Gemini - Art in Motion, Beta Lounge (11.02.1999)",
  content: `Spencer Kincy also known as Gemini is a prolific producer and DJ rising from Chicago's second wave of underground artists. From 1994 to 1999 Spencer released over 200 tracks on various labels, while never compromising in their quality. Although few of his recordings are available online, all of them showcase Spencer's incredible mixing skills and track selection.`,
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/spencer-kincy-aka-gemini-art-in-motion-beta-lounge-11021999",
  category: "Lost Gem",
  translationsBg: {
    content: `Спенсър Кинси, известен още като Джемини, е плодовит продуцент и диджей, изгряващ от втората вълна ъндърграунд артисти в Чикаго. От 1994 до 1999 г. Спенсър издава над 200 парчета за различни лейбъли, без никога да прави компромис с качеството им. Въпреки че малко от записите му са достъпни онлайн, всички те показват невероятните умения на Спенсър за миксиране и подбор на песни.`,
  },
};

export default post;
